module.exports = __webpack_public_path__ + "img/17.3a230de1.jpg";